import { render, staticRenderFns } from "./auditgoodsdetail.vue?vue&type=template&id=5366d67e&scoped=true"
import script from "./auditgoodsdetail.vue?vue&type=script&lang=js"
export * from "./auditgoodsdetail.vue?vue&type=script&lang=js"
import style0 from "./auditgoodsdetail.vue?vue&type=style&index=0&id=5366d67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366d67e",
  null
  
)

export default component.exports